export { VitalsApi, VitalsAggregateMergedResult } from './vitals';
export { NotesApi } from './notes';
export { VideoConsultApi } from './video-consult';
export { PatientApi, OnboardApi as PatientOnboardApi, PatientEndpoint } from './patient';
export { DeviceApi } from './device';
export { PractitionerApi } from './practitioner';
export { MediaApi, MediaEndpoint } from './media';
export { AdmissionApi, admissionSWRKey } from './admission';
export { OrganizationApi } from './organization';
export { GroupApi } from './group';
export { MedicationApi } from './medication';
export { GooglePlaceApi } from './google-place';
export { PathologyApi } from './pathology';
export { SpecialtyApi } from './specialty';
export { ObservationApi } from './observation';
export { DeviceAssociationApi } from './device-association';
export { LocationApi } from './location';
export { ChargeItemApi } from './charge-item';
export { MedicalAidApi } from './medical-aid';
export { ClaimTemplateApi } from './claim-template';
export { ClaimApi } from './claim';
export { ClaimResponseApi } from './claim-response';
export { TaskApi } from './task';
export { ConsumableApi } from './consumable';
export { CareTeamApi } from './care-team';
export { CoverageApi } from './coverage';
export { NextOfKinApi } from './next-of-kin';
export { CommunicationApi } from './communication';
export { DocumentApi } from './document';
export { CarePlanApi } from './care-plan';
